<template>
  <section>
    <v-card>
      <v-toolbar color="#050048" dark flat dense>
        <span>{{ formtitle }} Rate Logs</span>
        <v-spacer></v-spacer>
        <v-btn depressed icon @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table fixed-header  height="55vh"
        :headers="dessertHeaders"
        :items="RatesSummary"
        :search="search"
        dense
        item-key="rate_id"
      >
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            title="reload"
            @click="item(item)"
            color="primary"
            class="mr-2"
          >
            mdi-reload
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  name: "FX Cost Schedule",
  data() {
    return {
      valid: true,
      search: "",
      dessertHeaders: [
        { text: "Country", value: "country", sortable: false, width: "150px" },
        {
          text: `Rate`,
          value: "cost_rate",
          sortable: false,
          width: "150px",
        },
        {
          text: "Currency",
          value: "currency",
          sortable: false,
          width: "100px",
        },

        {
          text: `Rate`,
          value: "rate_source",
          sortable: false,
          width: "150px",
        },
        {
          text: `Updated By`,
          value: "updated_by",
          sortable: false,
          width: "150px",
        },
        {
          text: `Updated Date`,
          value: "updated_date",
          sortable: false,
          width: "150px",
        },
        { text: "Action", value: "action", sortable: false, width: "30px" },
      ],

      RatesSummary: [
        {
          country: "india",
          cost_rate: "17.4",
          currency: "INR",
          rate_source: "tranglo",
          updated_by: "agent tom",
          updated_date: "20-12-2000",
        },
      ],
    };
  },
  methods: {
    closeDialog() {
      this.$emit("closeRateLogs");
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
